const size = {
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1600px',
}

export const device = {
  sm: `(min-width: ${size.sm})`,
  md: `(min-width: ${size.md})`,
  lg: `(min-width: ${size.lg})`,
  xl: `(min-width: ${size.xl})`,
  xxl: `(min-width: ${size.xxl})`,
}

const theme = {
  colors: {
    primary: '#48bb78',
    primaryLight: '#80d0a1',
    white: '#ffffff',
    gray: '#edf2f7',
    teal: '#38b2ac',
    tealLight: '#67cfca',
    background: '#202124',
  },
}

export default theme
